import { Size } from '../../primitives/size';
import { DiagramElement } from './diagram-element';
import { measureText } from './../../utility/dom-util';
/**
 * TextElement is used to display text/annotations
 */
export class TextElement extends DiagramElement {
    /**
     * set the id for each element
     */
    constructor() {
        super();
        /**
         * sets or gets the image source
         */
        this.textContent = '';
        /** @private */
        this.canMeasure = true;
        /**Gets or sets the reference mode for annotation rotation. */
        /** @private */
        this.rotationReference = 'Parent';
        /** @private */
        this.isLaneOrientation = false;
        /** @private */
        this.canConsiderBounds = true;
        /** @private */
        this.annotationVisibility = 'Visible';
        /**
         * sets the hyperlink color to blue
         */
        this.hyperlink = {
            color: 'blue'
        };
        /** @private */
        this.doWrap = true;
        this.textNodes = [];
        /**
         * Defines the appearance of the text element
         */
        this.style = {
            color: 'black', fill: 'transparent', strokeColor: 'black',
            strokeWidth: 1, fontFamily: 'Arial', fontSize: 12, whiteSpace: 'CollapseSpace',
            textWrapping: 'WrapWithOverflow', textAlign: 'Center', italic: false, bold: false,
            textDecoration: 'None', strokeDashArray: '', opacity: 5, gradient: null,
            textOverflow: 'Wrap'
        };
        this.style.fill = 'transparent';
        this.style.strokeColor = 'transparent';
    }
    /**
     *   gets the content for the text element \
     *
     * @returns { string | SVGElement }  gets the content for the text element.\
     *
     * @private
     */
    get content() {
        return this.textContent;
    }
    /**
     *   sets the content for the text element \
     *
     * @returns { void }  sets the content for the text element.\
     * @param {string} value - provide the id value.
     *
     * @private
     */
    set content(value) {
        if (this.textContent !== value) {
            this.textContent = value;
            this.isDirt = true;
            this.doWrap = true;
        }
    }
    /**
     *   gets the content for the text element \
     *
     * @returns { string | SVGElement }  gets the content for the text element.\
     *
     * @private
     */
    get childNodes() {
        return this.textNodes;
    }
    /**
     *   sets the content for the text element \
     *
     * @returns { void }  sets the content for the text element.\
     * @param {SubTextElement[]} value - provide the id value.
     *
     * @private
     */
    set childNodes(value) {
        this.textNodes = value;
    }
    /**
     *   gets the wrapBounds for the text \
     *
     * @returns { string | SVGElement }  gets the wrapBounds for the text.\
     *
     * @private
     */
    get wrapBounds() {
        return this.textWrapBounds;
    }
    /**
     *    sets the wrapBounds for the text \
     *
     * @returns { void }   sets the wrapBounds for the text.\
     * @param {TextBounds} value - provide the id value.
     *
     * @private
     */
    set wrapBounds(value) {
        this.textWrapBounds = value;
    }
    /**
     *    sets the wrapBounds for the text \
     *
     * @returns { void }   sets the wrapBounds for the text.\
     *
     * @private
     */
    refreshTextElement() {
        this.isDirt = true;
    }
    /**
     *Measures the minimum size that is required for the text element\
     *
     * @returns { Size }  Measures the minimum size that is required for the text element.\
     * @param {Size} availableSize - provide the id value.
     *
     * @private
     */
    measure(availableSize) {
        let size;
        if (this.isDirt && this.canMeasure) {
            size = measureText(this, this.style, this.content, this.isLaneOrientation ?
                availableSize.height : (this.width || availableSize.width));
        }
        else {
            size = this.desiredSize;
        }
        if (this.width === undefined || this.height === undefined) {
            this.desiredSize = new Size(size.width, size.height);
        }
        else {
            this.desiredSize = new Size(this.width, this.height);
        }
        this.desiredSize = this.validateDesiredSize(this.desiredSize, availableSize);
        return this.desiredSize;
    }
    /**
     * Arranges the text element\
     *
     * @returns { Size }   Arranges the text element.\
     * @param {Size} desiredSize - provide the id value.
     *
     * @private
     */
    arrange(desiredSize) {
        if (desiredSize.width !== this.actualSize.width || desiredSize.height !== this.actualSize.height || this.isDirt) {
            this.doWrap = true;
        }
        this.actualSize = desiredSize;
        this.updateBounds();
        this.isDirt = false;
        return this.actualSize;
    }
}
